import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import apiFetch from "../../../../shared/services/apiClient";
import { FiltrosBarra } from "./BalanceComprobacion";
import invoiceStyles from "../../invoices/styles/invoice.module.css";

const BASE = process.env.REACT_APP_API_URL ?? "";

async function descargarPDF(url, filename, setLoading, setError) {
  setLoading(true);
  setError("");
  try {
    const token = localStorage.getItem("access_token");
    const res = await window.fetch(`${BASE}${url}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.detail || `Error ${res.status}`);
    }
    const blob = await res.blob();
    const href = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href; a.download = filename; a.click();
    URL.revokeObjectURL(href);
  } catch (e) {
    setError(e.message);
  } finally {
    setLoading(false);
  }
}

// ── Modal de firma ────────────────────────────────────────────────────────────
function ToggleGroup({ value, options, onChange }) {
  return (
    <div style={{ display: "flex", gap: 6 }}>
      {options.map(({ key, label }) => {
        const active = value === key;
        return (
          <button key={key} onClick={() => onChange(key)}
            style={{ padding: "5px 14px", borderRadius: 6,
              border: `1px solid ${active ? "#f97316" : "var(--border-card)"}`,
              background: active ? "rgba(249,115,22,0.12)" : "transparent",
              color: active ? "#f97316" : "var(--text-muted)",
              fontWeight: active ? 700 : 400, fontSize: "0.84rem", cursor: "pointer",
              transition: "all 0.15s" }}>
            {label}
          </button>
        );
      })}
    </div>
  );
}

function FirmaModal({ onConfirm, onCancel }) {
  const { t } = useTranslation();
  const [incluirFirma, setIncluirFirma] = useState(true);
  const [campoFirma,   setCampoFirma]   = useState("");
  const [moneda,       setMoneda]       = useState("CRC");
  const [idioma,       setIdioma]       = useState("es");

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1000,
      background: "rgba(0,0,0,0.75)", backdropFilter: "blur(4px)",
      display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={onCancel}>
      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-card)",
        borderRadius: 12, width: "min(480px,94vw)", padding: 28 }}
        onClick={e => e.stopPropagation()}>
        <h3 style={{ color: "var(--text-primary)", margin: "0 0 18px" }}>
          <i className="fa-solid fa-file-signature" style={{ marginRight: 8, color: "#f97316" }}/>
          {t("reportes.opcionesPDF")}
        </h3>

        {/* Moneda */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: "0.78rem", color: "var(--text-secondary)",
            fontWeight: 600, marginBottom: 8 }}>
            {t("reportes.monedaReporte")}
          </div>
          <ToggleGroup value={moneda} onChange={setMoneda}
            options={[{ key: "CRC", label: "₡ Colones" }, { key: "USD", label: "$ Dólares" }]}/>
        </div>

        {/* Idioma */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: "0.78rem", color: "var(--text-secondary)",
            fontWeight: 600, marginBottom: 8 }}>
            {t("reportes.idiomaReporte")}
          </div>
          <ToggleGroup value={idioma} onChange={setIdioma}
            options={[{ key: "es", label: "🇨🇷 Español" }, { key: "en", label: "🇺🇸 English" }]}/>
        </div>

        {/* Firma */}
        <label style={{ display: "flex", alignItems: "center", gap: 10,
          cursor: "pointer", marginBottom: 16 }}>
          <input type="checkbox" checked={incluirFirma}
            onChange={e => setIncluirFirma(e.target.checked)}
            style={{ accentColor: "#f97316", width: 16, height: 16 }}/>
          <div>
            <div style={{ color: "var(--text-primary)", fontSize: "0.88rem", fontWeight: 600 }}>
              {t("reportes.incluirFirma")}
            </div>
            <div style={{ color: "var(--text-muted)", fontSize: "0.77rem" }}>
              {t("reportes.firmaDesc")}
            </div>
          </div>
        </label>

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: "0.78rem", color: "var(--text-secondary)",
            display: "block", marginBottom: 6, fontWeight: 600 }}>
            {t("reportes.segundoFirmante")}
          </label>
          <input type="text" value={campoFirma}
            onChange={e => setCampoFirma(e.target.value)}
            placeholder={t("reportes.segundoFirmantePlaceholder")}
            style={{ width: "100%", background: "var(--bg-input)",
              border: "1px solid var(--border-input)", borderRadius: 6,
              color: "var(--text-primary)", padding: "8px 12px", fontSize: "0.85rem",
              boxSizing: "border-box" }}/>
        </div>

        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onCancel}
            style={{ padding: "8px 18px", background: "var(--hover-bg)",
              border: "1px solid var(--border-card)", borderRadius: 7,
              color: "var(--text-secondary)", cursor: "pointer" }}>
            {t("common.cancelar")}
          </button>
          <button onClick={() => onConfirm({ incluirFirma, campoFirma, moneda, idioma })}
            style={{ padding: "8px 18px", background: "#f97316",
              border: "none", borderRadius: 7,
              color: "#fff", fontWeight: 700, cursor: "pointer" }}>
            <i className="fa-solid fa-file-pdf" style={{ marginRight: 6 }}/>
            {t("reportes.generarPDFBtn")}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function finDeMes(desde) {
  if (!desde) return "";
  const [y, m] = desde.split("-").map(Number);
  const ultimo = new Date(y, m, 0);
  return ultimo.toISOString().split("T")[0];
}

// ── Componente principal ──────────────────────────────────────────────────────
export default function EstadoFinanciero() {
  const { t, i18n } = useTranslation();

  const fmtLindo = (iso) => {
    if (!iso) return "—";
    const date = new Date(iso + "T00:00:00");
    const locale = i18n.resolvedLanguage === "en" ? "en-US" : "es-CR";
    return date.toLocaleDateString(locale, { day: "numeric", month: "long", year: "numeric" });
  };

  const SECCIONES = [
    { icon: "fa-chart-bar",        n: "01", labelKey: "reportes.sec01Label", descKey: "reportes.sec01Desc", color: "#f97316" },
    { icon: "fa-scale-balanced",   n: "02", labelKey: "reportes.sec02Label", descKey: "reportes.sec02Desc", color: "#60a5fa" },
    { icon: "fa-note-sticky",      n: "03", labelKey: "reportes.sec03Label", descKey: "reportes.sec03Desc", color: "#a78bfa" },
    { icon: "fa-users",            n: "04", labelKey: "reportes.sec04Label", descKey: "reportes.sec04Desc", color: "#4ade80" },
    { icon: "fa-building",         n: "05", labelKey: "reportes.sec05Label", descKey: "reportes.sec05Desc", color: "#fb923c" },
    { icon: "fa-building-columns", n: "06", labelKey: "reportes.sec06Label", descKey: "reportes.sec06Desc", color: "#34d399" },
  ];

  const now       = new Date();
  const mesInicio = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}-01`;
  const mesFin    = finDeMes(mesInicio);

  const [fechaDesde, setFechaDesde] = useState(mesInicio);
  const [fechaHasta, setFechaHasta] = useState(mesFin);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState("");
  const [showModal,  setShowModal]  = useState(false);

  function handleDesdeChange(val) {
    setFechaDesde(val);
    setFechaHasta(finDeMes(val));
  }

  function buildQS(opts = {}) {
    const qs = new URLSearchParams();
    if (fechaDesde) qs.set("fecha_desde", fechaDesde);
    if (fechaHasta) qs.set("fecha_hasta", fechaHasta);
    qs.set("incluir_firma", opts.incluirFirma ? "true" : "false");
    if (opts.campoFirma) qs.set("campo_firma", opts.campoFirma);
    if (opts.moneda) qs.set("moneda", opts.moneda);
    if (opts.idioma) qs.set("idioma", opts.idioma);
    return qs.toString();
  }

  function handleGenerar() { setShowModal(true); }

  function handleConfirm(opts) {
    setShowModal(false);
    const url = `/api/finance/reportes/estado-financiero/?${buildQS(opts)}`;
    const fn  = `estados_financieros_${fechaHasta.replace(/-/g,"")}.pdf`;
    descargarPDF(url, fn, setLoading, setError);
  }

  return (
    <>
      <span className={invoiceStyles.inactive}>
        <Link to="/">
          <span className={invoiceStyles.inactive}>{t("common.inicio")} /</span>
        </Link>
        <span className={invoiceStyles.active}> {t("reportes.estadoFinanciero")}</span>
      </span>
      <div>
        <h2 className="title mt-2 mb-2">{t("reportes.estadoFinanciero")}</h2>
        <p className="mb-3" style={{ color: "var(--text-muted)" }}>{t("reportes.estadoFinancieroDesc")}</p>
      </div>

      {/* ── Panel selector de fechas ── */}
      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-card)",
        borderRadius: 12, padding: "22px 24px", marginBottom: 24 }}>

        {error && (
          <div style={{ background: "rgba(248,113,113,0.08)",
            border: "1px solid rgba(248,113,113,0.25)", borderLeft: "3px solid #f87171",
            borderRadius: 8, padding: "10px 14px", marginBottom: 18,
            color: "#fca5a5", fontSize: "0.83rem",
            display: "flex", alignItems: "center", gap: 8 }}>
            <i className="fa-solid fa-circle-exclamation"/>
            {error}
          </div>
        )}

        <div style={{ display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)", gap: 16, alignItems: "flex-end" }}>

          {/* DESDE */}
          <div>
            <label style={{ display: "block", fontSize: "0.68rem", fontWeight: 700,
              letterSpacing: "1px", textTransform: "uppercase",
              color: "var(--text-muted)", marginBottom: 8 }}>
              {t("reportes.desde")}
            </label>
            <div style={{ background: "var(--bg-input)", border: "1px solid var(--border-input)",
              borderRadius: 8, padding: "10px 14px",
              display: "flex", alignItems: "center", gap: 10 }}>
              <i className="fa-regular fa-calendar"
                 style={{ color: "#f97316", fontSize: "0.88rem", flexShrink: 0 }}/>
              <input type="date" value={fechaDesde}
                onChange={e => handleDesdeChange(e.target.value)}
                style={{ background: "transparent", border: "none", outline: "none",
                  color: "var(--text-primary)", fontSize: "0.88rem", fontWeight: 600,
                  colorScheme: "light dark", cursor: "pointer", flex: 1, width: "100%" }}/>
            </div>
            <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", marginTop: 4, paddingLeft: 2 }}>
              {fmtLindo(fechaDesde)}
            </div>
          </div>

          {/* HASTA — solo lectura, se calcula automático */}
          <div>
            <label style={{ display: "block", fontSize: "0.68rem", fontWeight: 700,
              letterSpacing: "1px", textTransform: "uppercase",
              color: "var(--text-muted)", marginBottom: 8 }}>
              {t("reportes.hasta")}
              <span style={{ marginLeft: 6, fontWeight: 400, color: "var(--text-muted)",
                fontSize: "0.62rem", textTransform: "none", letterSpacing: 0 }}>
                {t("reportes.finMesAutomatico")}
              </span>
            </label>
            <div style={{ background: "var(--bg-input)", border: "1px solid var(--border-input)",
              borderRadius: 8, padding: "10px 14px",
              display: "flex", alignItems: "center", gap: 10,
              opacity: 0.7 }}>
              <i className="fa-regular fa-calendar-check"
                 style={{ color: "#4ade80", fontSize: "0.88rem", flexShrink: 0 }}/>
              <span style={{ color: "var(--text-primary)", fontSize: "0.88rem",
                fontWeight: 600, fontFamily: "monospace" }}>
                {fechaHasta}
              </span>
            </div>
            <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", marginTop: 4, paddingLeft: 2 }}>
              {fmtLindo(fechaHasta)}
            </div>
          </div>
        </div>

        {/* Resumen período */}
        {fechaDesde && fechaHasta && (
          <div style={{ marginTop: 16, paddingTop: 14,
            borderTop: "1px solid var(--border-card)",
            display: "flex", alignItems: "center", gap: 8 }}>
            <i className="fa-solid fa-circle-info"
               style={{ color: "var(--text-muted)", fontSize: "0.78rem" }}/>
            <span style={{ fontSize: "0.78rem", color: "var(--text-muted)" }}>
              {t("reportes.periodo")}{" "}
              <strong style={{ color: "var(--text-secondary)" }}>
                {fmtLindo(fechaDesde)} — {fmtLindo(fechaHasta)}
              </strong>
            </span>
          </div>
        )}
      </div>

      {/* ── Secciones del PDF ── */}
      <div style={{ marginBottom: 8 }}>
        <p style={{ margin: "0 0 16px", fontSize: "0.7rem", fontWeight: 700,
          letterSpacing: "2px", textTransform: "uppercase",
          color: "var(--text-muted)", textAlign: "center" }}>
          {t("reportes.contenidoPDF")}
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
          {SECCIONES.map(({ icon, n, labelKey, descKey, color }) => (
            <div key={n}
              style={{ background: "var(--bg-card)", border: "1px solid var(--border-card)",
                borderRadius: 12, padding: "18px 20px",
                display: "flex", alignItems: "center", gap: 14,
                position: "relative", overflow: "hidden",
                transition: "border-color 0.15s, transform 0.1s" }}
              onMouseOver={e => {
                e.currentTarget.style.borderColor = color + "55";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseOut={e => {
                e.currentTarget.style.borderColor = "var(--border-card)";
                e.currentTarget.style.transform = "translateY(0)";
              }}>

              {/* Número decorativo de fondo */}
              <span style={{ position: "absolute", right: 12, top: "50%",
                transform: "translateY(-50%)", fontSize: "3.8rem", fontWeight: 900,
                fontFamily: "'Montserrat',sans-serif", color: color + "12",
                lineHeight: 1, userSelect: "none", letterSpacing: "-2px",
                pointerEvents: "none" }}>
                {n}
              </span>

              {/* Ícono */}
              <div style={{ width: 42, height: 42, borderRadius: 10, flexShrink: 0,
                background: color + "14", border: `1px solid ${color}28`,
                display: "flex", alignItems: "center", justifyContent: "center" }}>
                <i className={`fa-solid ${icon}`} style={{ color, fontSize: "1rem" }}/>
              </div>

              {/* Texto */}
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: "0.87rem", fontWeight: 700,
                  color: "var(--text-primary)", lineHeight: 1.3, marginBottom: 3 }}>
                  {t(labelKey)}
                </div>
                <div style={{ fontSize: "0.74rem", color: "var(--text-muted)" }}>{t(descKey)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Botón principal ── */}
      <div style={{ marginTop: 24, display: "flex", justifyContent: "center" }}>
        <button onClick={handleGenerar} disabled={loading}
          style={{ background: "#f97316", border: "none", borderRadius: 10,
            padding: "13px 40px", color: "#fff", fontWeight: 700, fontSize: "1rem",
            cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1,
            display: "flex", alignItems: "center", gap: 10,
            boxShadow: "0 8px 28px rgba(249,115,22,0.32)",
            transition: "all 0.15s" }}
          onMouseOver={e => { if (!loading) { e.currentTarget.style.background = "#ea6b10"; e.currentTarget.style.transform = "translateY(-1px)"; }}}
          onMouseOut={e  => { if (!loading) { e.currentTarget.style.background = "#f97316";  e.currentTarget.style.transform = "translateY(0)"; }}}>
          {loading
            ? <><i className="fa-solid fa-circle-notch fa-spin"/> {t("reportes.generandoPDF")}</>
            : <><i className="fa-solid fa-file-pdf" style={{ fontSize: "1.1rem" }}/> {t("reportes.generarPDF")}</>}
        </button>
      </div>

      <p style={{ textAlign: "center", marginTop: 12,
        fontSize: "0.74rem", color: "var(--text-muted)" }}>
        {t("reportes.descargaAuto")}
      </p>

      {/* ── Modal de firma ── */}
      {showModal && (
        <FirmaModal onConfirm={handleConfirm} onCancel={() => setShowModal(false)}/>
      )}
    </>
  );
}

// ── Hook reutilizable ─────────────────────────────────────────────────────────
export function usePDFIndividual(endpoint, filename) {
  const [loading,     setLoading]     = useState(false);
  const [error,       setError]       = useState("");
  const [showModal,   setShowModal]   = useState(false);
  const [pendingOpts, setPendingOpts] = useState(null);

  function generar(extraQS = "") {
    setShowModal(true);
    setPendingOpts(extraQS);
  }

  function confirmar(opts) {
    setShowModal(false);
    const qs = new URLSearchParams(pendingOpts || "");
    qs.set("incluir_firma", opts.incluirFirma ? "true" : "false");
    if (opts.campoFirma) qs.set("campo_firma", opts.campoFirma);
    if (opts.moneda) qs.set("moneda", opts.moneda);
    if (opts.idioma) qs.set("idioma", opts.idioma);
    descargarPDF(`${endpoint}?${qs}`, filename, setLoading, setError);
  }

  const modal = showModal
    ? <FirmaModal onConfirm={confirmar} onCancel={() => setShowModal(false)}/>
    : null;

  return { loading, error, generar, modal };
}
